import React from "react";

export default () => {
  return (
    <React.Fragment>
      <rect x="18" y="15" rx="4" ry="4" width="35" height="35" />
      <rect x="70" y="25" rx="3" ry="3" width="220" height="5" />
      <rect x="70" y="37" rx="3" ry="3" width="200" height="5" />
    </React.Fragment>
  );
};
